export interface CosThumbnailOptions {
  width: number;
  height: number;
  quality: number;
  format?: 'jpg' | 'webp';
}

const COS_IMAGE_PROCESS_PATTERN = /(?:[?&](?:imageMogr2|imageView2)(?:[=/&]|$)|[?&]ci-process=)/i;

function clampInteger(value: number, min: number, max: number): number {
  if (!Number.isFinite(value)) {
    return min;
  }
  return Math.min(max, Math.max(min, Math.round(value)));
}

export function buildCosThumbnailUrl(value: string, options: CosThumbnailOptions): string {
  const trimmed = value.trim();
  if (!/^https?:\/\//i.test(trimmed) || COS_IMAGE_PROCESS_PATTERN.test(trimmed)) {
    return trimmed;
  }

  const hashIndex = trimmed.indexOf('#');
  const withoutHash = hashIndex >= 0 ? trimmed.slice(0, hashIndex) : trimmed;
  const hash = hashIndex >= 0 ? trimmed.slice(hashIndex) : '';
  const separator = withoutHash.includes('?') ? '&' : '?';
  const width = clampInteger(options.width, 1, 4096);
  const height = clampInteger(options.height, 1, 4096);
  const quality = clampInteger(options.quality, 1, 100);

  const format = options.format ? `/format/${options.format}` : '';
  return `${withoutHash}${separator}imageMogr2/thumbnail/${width}x${height}/quality/${quality}${format}${hash}`;
}

export const EVIDENCE_THUMBNAIL_OPTIONS: CosThumbnailOptions = { width: 320, height: 480, quality: 75, format: 'jpg' };

// The backend signs the object path and host, with an empty q-url-param-list.
// COS supports adding image processing parameters to that private read URL.
// Keep the original signature/query bytes intact; the original URL is for click-to-view only.
export function buildEvidenceThumbnailUrl(originalUrl: string): string {
  return buildCosThumbnailUrl(originalUrl, EVIDENCE_THUMBNAIL_OPTIONS);
}
